import { useRef, useState } from "react";
import { api, stableMediaUrl } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { inputCls } from "./constants";

export function MediaInput({ label, value, onChange, testid, accept = "image/*,video/*" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const previewUrl = typeof value === "string" ? value.trim() : "";

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(stableMediaUrl(r.data.url));
      toast.success("Uploaded");
    } catch { toast.error("Upload failed"); }
    finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div>
      <Label className="text-[11px] font-mono uppercase tracking-[0.1em] text-[#475467]">{label}</Label>
      <div className="flex gap-2 mt-1">
        <Input data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="https://… or upload" className={`${inputCls} mt-0 flex-1`} />
        <Button type="button" variant="outline" className="rounded-xl border-[#E4E9F0]" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testid}-upload`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" strokeWidth={1.5} />}
        </Button>
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={upload} />
      </div>
      {previewUrl && /\.(jpe?g|png|webp|gif|svg)(\?|$)|unsplash|pexels-photo|customer-assets|public\/media/i.test(previewUrl) && !/\.mp4/i.test(previewUrl) && (
        <img src={previewUrl} alt="" className="mt-2 h-20 w-32 object-cover rounded-xl border border-[#E4E9F0]" />
      )}
    </div>
  );
}
